import styled from 'styled-components';
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

const Wrapper = styled.div`
  margin-bottom: 38px;

  .title-wrapper {
    padding-bottom: 5px;
  }
  h1 {
    color: #030000;
    font-size: 17px;
    font-family: Futura;
    font-weight: 500;
  }
  span {
    font-size: 8px;
    font-weight: 700;
  }
`;

const Title = (props) => {
  const lines = props.title.split('\n');
  return (
    <Wrapper>
      <FadeInFromBottom>
        <div className='title-wrapper'>
          {lines.map((line, index) => (
              <h1 key={index}>{line}</h1>
          ))}
        </div>
        <span>{props.subTitle}</span>
      </FadeInFromBottom>
    </Wrapper>
  );
};
  
export default Title;
  